"use client";

import { motion } from "framer-motion";

import Image from "@/app/_components/Image";

import styles from "./ActivitiesSection.module.scss";

type Props = {
  id: number;
  title: string;
  description: string;
  image: string;
};

export default function ActivitiesCard({
  title,
  description,
  image,
}: Props) {
  return (
    <motion.article
      className={styles.card}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      <div className={styles.imageWrapper}>
        <Image
          src={image}
          alt={title}
          title={title}
          fill
          className={styles.image}
          sizes="(max-width: 768px) 100vw, 50vw"
          quality={70}
          loading="lazy"
        />
      </div>

      <div className={styles.content}>
        <h3>{title}</h3>

        <p>{description}</p>
      </div>
    </motion.article>
  );
}